import React from 'react';
import LoginForm from '../components/forms/loginForm';

export default function Login() {
  return <LoginForm />;
}
